<template>
  <div>

        <video 
            :autoplay="true" 
            :controls="false" 
            loop 
            playsinline 
            id="myVideo" 
            @click="playVideo" 
            :style="{position: 'absolute',
            top: $store.getters.getScreenWidth>500 ? '0%' : '5%',
            bottom: 0,
            right: 0, 
            left: '0%',
            margin: 'auto',
            width: '100%',
            minWidth: '100%',
            filter: 'opacity(100%)', zIndex: '-999'}" data-source-type='video'
            data-movie-id='194603' poster='https://raizzoncdn.b-cdn.net/coastalkia5k/poster.jpeg'>
                <!--https://xcorder.s3.us-east-1.amazonaws.com/148/445735650/S7E24S/video/S7E24S_720p.mp4-->        
                <source 
                    src="https://shaklee-plugin.b-cdn.net/CSK_Shaklee_2024_c.mp4" 
                    type="video/mp4">
            
        </video>
  </div>
</template>

<script>
export default {
  methods: {
    playVideo() {
      console.log("VIDEO PLAYED")
      document.getElementById('myVideo').play()
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/BGVideo.vue